import lodash from "lodash";

const constructCountryOptions = (countryMappingDetails = []) => {
    const countryNameOptions = [{ id: '', label: 'Select Country' }];
    countryMappingDetails.map(country => countryNameOptions.push({ id: country.countryCode, label: country.countryCode }));
    return countryNameOptions
}

const constructCurrencyOptions = (countryMappingDetails = [], selectedCountry) => {
    const currencyOptions = [{ id: '', label: 'Select Currency' }];
    const selectedCountryMapping = countryMappingDetails.find(countryMapping => countryMapping.countryCode === selectedCountry) || {};
    const { countryCurrencyList = [] } = selectedCountryMapping;
    countryCurrencyList.map(currency => currencyOptions.push({ id: currency, label: currency }));
    return currencyOptions
}

const constructVendorOptions = (countryMappingDetails = [], selectedCountry) => {
    const vendorOptions = [{ id: '', label: 'Select Vendor' }];
    const selectedCountryMapping = countryMappingDetails.find(countryMapping => countryMapping.countryCode === selectedCountry) || {};
    const { vendors = [] } = selectedCountryMapping;
    vendors.map(vendor => vendorOptions.push({ id: vendor, label: vendor }));
    return vendorOptions
}

const constructAutoVendorOptions = (vendorList = []) => {
    return [{ id: '', label: 'Select Vendor' }, ...vendorList.map(vendor => ({ id: vendor.vendorName, label: vendor.vendorName }))];
}
const constructPaymentTypeOptions = (countryMappingDetails = [], selectedCountry, vendorName) => {
    const paymentTypeOptions = [{ id: '', label: 'Select Payment Type' }];
    const selectedCountryMapping = countryMappingDetails.find(countryMapping => countryMapping.countryCode === selectedCountry) || {};
    const { countryPaymentMap = {} } = selectedCountryMapping;
    if (vendorName && countryPaymentMap[`${vendorName}`]?.length) {
        countryPaymentMap[`${vendorName}`].map(paymentType => paymentTypeOptions.push({ id: paymentType, label: paymentType }));
    }
    return paymentTypeOptions
}

const constructLogisticsService = () => {
    const serviceOptions = [{ id: '', label: 'Select Special Logistics' },
    { id: 'Available', label: 'Available' },
    { id: 'Not Available', label: 'Not Available' }];
    return serviceOptions
}

const constructOnsiteProcessingService = () => {
    const serviceOptions = [{ id: '', label: 'Select Onsite Processing' },
    { id: 'Available', label: 'Available' },
    { id: 'Not Available', label: 'Not Available' }];
    return serviceOptions
}

const revitalizeInCountryOptions = () => {
    const revitalizeCountryOptions = [
        { id: 'Not active', label: 'Not active' },
        { id: 'Active', label: 'Active' },
        { id: 'Not available', label: 'Not available' }
    ];
    return revitalizeCountryOptions
}

const nonRevitalizeInCountryOptions = () => {
    const revitalizeCountryOptions = [
        { id: 'Not available', label: 'Not available' }
    ];
    return revitalizeCountryOptions
}

const getDirectCustomerPricingOptions = () => {
    const pricingOptions = [{ id: '', label: 'Select Pricing Option' },
    { id: 'Margins only', label: 'Margins only' },
    { id: 'Customer Service RateCard', label: 'Customer Service RateCard' }];
    return pricingOptions
}
const getCustomerServiceRateCardOptions = (customerServiceRateCardList, country) => {
    const rateCardOptions = [{ id: 'HP Standard Customer Service Rate Card', label: 'HP Standard Customer Service Rate Card' }];
    const filteredData = customerServiceRateCardList.filter(item => item.countryCode === country);
    filteredData.map(rateCard => rateCardOptions.push({ id: rateCard.priceList, label: rateCard.priceList }));
    return rateCardOptions
}

export default function insertCountryAndPaymentTypeColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];
    const { countryMappingList = [], countryMappingDetails = [], customerServiceRateCardList = [], dealDetails = {}, revitalizeVendorList = [], isRetrieved = false } = config.data;

    countryMappingList.map((countryMapping, rowIndex) => {

        let row = [];
        const rowId = config.tableType;

        config.columns.forEach(column => {
            const columnId = column.id;
            const columnDataType = column.data.displayInBodyAs;
            let columnValue = null;
            let columnValueData = {};
            let customEventHandler = null;
            let isDisabled = false;

            if (columnDataType === "select") {
                let options = [];

                if (columnId === 'country') {
                    options = constructCountryOptions(countryMappingDetails);
                    columnValue = countryMapping.country;
                    isDisabled = countryMapping?.isRetrieved ? true : false;
                }
                else if (columnId === 'currency') {
                    options = constructCurrencyOptions(countryMappingDetails, countryMapping.country);
                    columnValue = countryMapping.currency || "";
                    isDisabled = countryMapping?.isRetrieved ? true : false;
                }
                else if (columnId === 'vendorName') {
                    if (countryMapping.vendorList && countryMapping.vendorList.length) {
                        columnValue = countryMapping.vendorName || "";
                        options = constructAutoVendorOptions(countryMapping.vendorList);
                    } else {
                        options = constructVendorOptions(countryMappingDetails, countryMapping.country);
                        columnValue = countryMapping.vendorName || "";
                        isDisabled = countryMapping?.isRetrieved ? true : false;
                    }
                }
                else if (columnId === 'paymentType') {
                    options = constructPaymentTypeOptions(countryMappingDetails, countryMapping.country, countryMapping.vendorName);
                    columnValue = countryMapping.paymentType || "";
                }
                else if (columnId === 'specialLogistics') {
                    options = constructLogisticsService();
                    columnValue = countryMapping.specialLogistics || "";
                }
                else if (columnId === 'onsiteProcessing') {
                    options = constructOnsiteProcessingService();
                    columnValue = countryMapping.onsiteProcessing || "";
                }
                else if (columnId === 'directCustomerPricing') {
                    if (countryMapping.paymentType === "No Customer Payment") {
                        isDisabled = true;
                    }
                    else {
                        options = getDirectCustomerPricingOptions();
                        columnValue = countryMapping.directCustomerPricing || "";
                        isDisabled = false;
                    }

                }
                else if (columnId === 'customerServiceRateCard') {
                    isDisabled = true;
                    if (countryMapping.directCustomerPricing === "Customer Service RateCard") {
                        options = getCustomerServiceRateCardOptions(customerServiceRateCardList, countryMapping.country);
                        columnValue = countryMapping.customerServiceRateCard || "";
                        isDisabled = false;
                    }
                }
                else if (columnId === 'revitalizeCountry') {
                    columnValue = countryMapping.revitalizeCountry || "";
                    let isRevitalizeVendor = false
                    revitalizeVendorList.map(item => {
                        if (item.country === countryMapping.country) {
                            isRevitalizeVendor = item.vendors.filter(vendor => vendor === countryMapping.vendorName).length ? true : false
                        }
                    })
                    if (isRevitalizeVendor) {
                        options = revitalizeInCountryOptions();
                    } else {
                        options = nonRevitalizeInCountryOptions();
                    }
                    if (dealDetails.revitalizeDeal === "Not active") {
                        isDisabled = true;
                    }
                    if (dealDetails.revitalizeDeal === "Active" && (!countryMapping.country || !countryMapping.vendorName)) {
                        isDisabled = true;
                    }
                }

                columnValueData = { ...column.data };
                columnValueData.options = options;
                columnValueData.defaultValue = columnValue;
                customEventHandler = config.bodyButtonsHandler.inputChangeHandler ? event => config.bodyButtonsHandler.inputChangeHandler(event, columnId, rowIndex, countryMapping.country) : null;
            }
            else if (column.data.displayInBodyAs == "deleteIcon" && column.id == "delete") {
                isDisabled = countryMapping?.isRetrieved ? true : false;
                customEventHandler = config.bodyButtonsHandler.handleDeleteCountryMappingAction ? event => config.bodyButtonsHandler.handleDeleteCountryMappingAction(event, countryMapping.country) : null;
            }

            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValueData,
                    width: column.width,
                    disabled: isDisabled,
                    displayAsIs: column.data.displayInBodyAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: column.data.highlightBodyText,
                    clickHandler: customEventHandler
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });

    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}